module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /home/sotsys211/work/src/ecard_new/backend/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main